export const NumFiveCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20.5791" r="18.6667" stroke="url(#paint0_linear_971_23874)" strokeWidth="2.66667"/>
            <path
                d="M26.436 25.2151C26.436 28.8391 23.76 30.9391 20.04 30.9391C16.788 30.9391 13.932 29.3551 13.2 25.4671L16.2 25.0111C16.608 27.0151 17.712 28.2271 20.1 28.2271C22.092 28.2271 23.412 26.9191 23.412 25.3351C23.412 23.5111 22.152 22.5511 20.04 22.5511H14.376L14.964 13.2991H25.26V16.0111H17.688L17.448 19.8271H20.1C24.204 19.8271 26.436 21.8791 26.436 25.2151Z"
                fill="url(#paint1_linear_971_23874)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23874" x1="22.7586" y1="-21.7738" x2="77.5901" y2="63.8423"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23874" x1="21.1034" y1="-11.7444" x2="66.8186" y2="25.0977"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};